import React, {useCallback, useMemo} from 'react';
import {Concept} from 'types';
import type {Agent} from 'services/agent/types';
import {useLocalization} from 'localization';
import {usePostNorafUpdatesIgnorelistMutation} from 'services/agent';
import {ActionButton, useSnacks} from 'components';
import {formatNameVariantValue} from 'schema/preview/functions';

type Props = {
  agent?: Agent;
};
export const AgentIgnoreButton: React.FC<Props> = ({agent}) => {
  const {t} = useLocalization();
  const [agentChangeIgnorer] = usePostNorafUpdatesIgnorelistMutation();
  const {successSnack} = useSnacks();

  const canIgnore = useMemo(() => {
    return (
      agent?.nationalId &&
      agent?.id &&
      agent?.nameVariants?.[0] &&
      agent?.agentType === Concept.person
    );
  }, [agent?.nationalId, agent?.id, agent?.nameVariants, agent?.agentType]);

  const onIgnore = useCallback(() => {
    if (agent?.nationalId && agent?.id && agent?.nameVariants?.[0]) {
      agentChangeIgnorer({
        nationalId: agent?.nationalId,
        agentId: agent?.id,
        name: formatNameVariantValue(
          agent?.nameVariants?.[0],
          agent?.agentType,
          'excludeId',
        ),
      }).then(() => {
        successSnack(t('page.agents.noraf.changes.ignore.success', {count: 1}));
      });
    }
  }, [
    agent?.agentType,
    agent?.id,
    agent?.nameVariants,
    agent?.nationalId,
    agentChangeIgnorer,
    successSnack,
    t,
  ]);

  if (!canIgnore) {
    return null;
  }

  return (
    <ActionButton
      onClick={onIgnore}
      background={'transparent'}
      title={'Ignorer endringer'}
    />
  );
};
